import { Injectable } from "@angular/core";
import { constants } from "../constants";

@Injectable()
export class LocalStorageService {
  constructor() {}

  setAdditionalState(state: string): void {
    localStorage.setItem(constants.additionalStateKeyInStorage, state);
  }

  getAdditionalState(): string {
    return localStorage.getItem(constants.additionalStateKeyInStorage);
  }

  clear() {
    localStorage.removeItem(constants.additionalStateKeyInStorage);
  }
}
 